import { createContext} from "react";

export const MainNavigationContext = createContext([]);